import { render, staticRenderFns } from "./EfsMdContractPriceListModal.vue?vue&type=template&id=10672a53&"
import script from "./EfsMdContractPriceListModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdContractPriceListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports